<template>
  <div>
    <div class="sellLogin-header">当前账号：{{ userInfo.nick_name }}
      <span @click="handleLogin">【点击切换】</span>
    </div>
    <img class="img" src="@/assets/images/sellCard/yinhe-active.jpg" />
    <div class="btn" @click="placeAnOrder(pid)">
      <img class="img" src="@/assets/images/sellCard/active-btn.gif" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'YinSource',
  props: {
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      pid: process.env.VUE_APP_yinHe
    }
  },
  methods: {
    placeAnOrder (pid) {
      // 增加曝光埋点
      const data = {
        login_type: localStorage.getItem('loginType'),
        open_id: this.userInfo.open_id,
        scenario: '普通支付',
        vip_name: '爱奇艺VIP购买',
        vip_duration: '7天',
        scanTool: '微信',
        page_name: '心动约惠七夕价',
        button_name: '特惠抢购'
      }
      window._cooc.push(['_trackEvent', 'aiqiyi_qg_vip_click', '点击', data])
      this.$service.placeAnOrder(pid).then(res => {
        if (res.code === 500) {
          this.$constants.onLogin()
        } else if (res.code === 501) {
          this.$constants.onLogin('weixin,qq')
        } else {
          window.location.href = res.url
        }
      })
    },
    handleLogin () {
      this.$emit('handleLogin')
    }
  }
}
</script>

<style lang="stylus" scoped>
  .sellLogin-header
    line-height 22px
    font-size 12px
    background #ff7f96
    color #fff
    padding 5px
  .img
    width 100%
    height 100%
    padding-bottom 50px
  .btn
    position fixed
    bottom 0
    left 0
    right 0
    height 60px
    background #ff7f96
    padding 0 20px 0 20px
</style>
